export const GET_MODULES_LIST = 'GET_MODULES_LIST';
export const ADD_MODULE = 'ADD_MODULE';
export const EDIT_MODULE = 'EDIT_MODULE';
export const DELETE_MODULE = 'DELETE_MODULE';
export const ADD_PREFERENCE = 'ADD_PREFERENCE';
export const EDIT_PREFERENCE = 'EDIT_PREFERENCE';
export const DELETE_PREFERENCE = 'DELETE_PREFERENCE';
export const APPLY_SORTING = 'APPLY_SORTING';

export function getModulesList(data, callback) {
  return {
    type: GET_MODULES_LIST,
    payload: {data, callback},
  }; 
}

export function addNewModule(data, callback) {
  return {
    type: ADD_MODULE,
    payload: {data, callback},
  }; 
}

export function editModule(data, callback) {
  return {
    type: EDIT_MODULE,
    payload: {data, callback},
  }; 
}

export function deleteModule(data, callback) {
  return {
    type: DELETE_MODULE,
    payload: {data, callback},
  }; 
}

export function addPreference(data, callback) {
  return {
    type: ADD_PREFERENCE,
    payload: {data, callback},
  }; 
}

export function editPreference(data, callback) {
  return {
    type: EDIT_PREFERENCE,
    payload: {data, callback},
  }; 
}

export function deletePreference(data, callback) {
  return {
    type: DELETE_PREFERENCE,
    payload: {data, callback},
  }; 
}

export function applySorting(data, callback) {
  return {
    type: APPLY_SORTING,
    payload: {data, callback},
  }; 
}